import React from 'react';
import styled from 'styled-components';
import SearchInput from './SearchInput';
import SearchIconButton from './SearchIconButton';

const SearchInputContainer = styled.div`
  position: relative;

  & input {
    width: 280px;
    // place clear button in input
    margin-right: -25px;
    padding-right: 25px;
    // create space for search button
    padding: 10px 10px 10px 38px;
  }
`;

const ClearButton = styled.span`
  display: inline-block;
  font-size: 16px;
  font-weight: bold;
  color: #edeeef;
  cursor: pointer;
`;

interface SearchProps {
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onKeyDown: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  onSearchClick: () => void;
  onClear: () => void;
  value: string;
  disabled: boolean;
}

const Search: React.FC<SearchProps> = ({
  onChange,
  onKeyDown,
  onSearchClick,
  onClear,
  value,
  disabled
}) => {
  return (
    <SearchInputContainer>
      <SearchInput
        onChange={onChange}
        onKeyDown={onKeyDown}
        value={value}
        disabled={disabled}
      />
      {value && !disabled && (
        // Did not add 'fa-times' because it renders quite thickly
        <ClearButton onClick={onClear}>&#x2715;</ClearButton>
      )}
      <SearchIconButton onClick={onSearchClick} disabled={disabled} />
    </SearchInputContainer>
  );
};

export default Search;
